











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Paginator extends Vue {
  @Prop() readonly page!: number;
  @Prop() readonly maxPage!: number;
  @Prop() readonly disabled: boolean | null = null;

  private handleNextPage(): void {
    this.$emit('pageChange', this.page + 1);
  }

  private handlePrevPage(): void {
    this.$emit('pageChange', this.page - 1);
  }
}
